import api from "../../axios/api.js";

export class DetailsService {
  async getDetails(serialNumber) {
    const data = await api.get(`/Details/${serialNumber}`);
    return data;
  }
}
